<template>
	<!-- <div> -->
      <router-view v-if="!isAuth"></router-view>
  <router-view v-else-if="tokenPainel!=''"></router-view>	  
  <v-app v-else-if="isAuth">

		<v-overlay :value="getShowLoading" absolute z-index="1000" opacity="0.2">
			<v-progress-circular
			indeterminate
			color="primary"
			></v-progress-circular>
		</v-overlay>

		
		<v-navigation-drawer app  v-model="drawer" color="#2f4050" :permanent="drawer">
			<v-list-item  dark style="background-color:#233645">
				<v-list-item-content >
				<v-list-item-title class="title">
					{{nameApp}}					
					<!-- <v-icon small>mdi-tune</v-icon> -->
				</v-list-item-title>
				<v-list-item-subtitle >
					Bem vindo, {{user.name}}
				</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>

			<v-divider></v-divider>

			<v-list dense nav dark expand
			>

				 <v-list-item @click="goto('/')">
					<v-list-item-icon >
						<v-icon >mdi-home</v-icon>
					</v-list-item-icon>

					<v-list-item-content >
						<v-list-item-title>Ínicio</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				<!-- {{menu[0].submenu}} -->
				<template v-if="menu && (Object.entries(menu).length>0 || menu.length>0)" >
					<item-menu v-for="m in menu" :key="m.id" :menu="m" ></item-menu>
				</template>
				<!-- <v-list-item link to="/enum">
					<v-list-item-icon >
						<v-icon >mdi-view-dashboard</v-icon>
					</v-list-item-icon>

					<v-list-item-content >
						<v-list-item-title>Enum</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				 -->

				<!-- <v-list-group
					:value="false"
					prepend-icon="mdi-account-circle"
				
				>
					<template v-slot:activator>
					<v-list-item-title >M Sistema</v-list-item-title>
					</template>


						<v-list-item link to="/menu">
							<v-list-item-icon >
								<v-icon >mdi-view-dashboard</v-icon>
							</v-list-item-icon>

							<v-list-item-content >
								<v-list-item-title>Menu</v-list-item-title>
							</v-list-item-content>
						</v-list-item>

						<v-list-item link to="/agregado">
							<v-list-item-icon >
								<v-icon >mdi-view-dashboard</v-icon>
							</v-list-item-icon>

							<v-list-item-content >
								<v-list-item-title>Agregado</v-list-item-title>
							</v-list-item-content>
						</v-list-item>


						<v-list-group
						:value="false"
						no-action
						sub-group
						>
						<template v-slot:activator>
							<v-list-item-content>
							<v-list-item-title>Admin</v-list-item-title>
							</v-list-item-content>
						</template>

						<v-list-item
							v-for="([title, icon], i) in admins"
							:key="i"
							link
						>
							<v-list-item-title v-text="title"></v-list-item-title>

							<v-list-item-icon>
							<v-icon v-text="icon"></v-icon>
							</v-list-item-icon>
						</v-list-item>
						</v-list-group>

					
				</v-list-group> -->
			</v-list>
		</v-navigation-drawer>

		<v-app-bar app  flat color="white">
			<v-app-bar-nav-icon @click="drawer = !drawer" color="primary"></v-app-bar-nav-icon>
			<v-spacer></v-spacer>
			
			<span class="mr-5" style="color:#D7D7D7">
			{{nameApp}}        
			</span>
			<span @click="logout" style="cursor:pointer">
			<v-icon>mdi-exit-to-app</v-icon>
			Sair
			</span>
			
		</v-app-bar>

		<!-- Sizes your content based upon application components -->
		<v-main  style="background-color:#F3F3F4" >
			<v-divider></v-divider>
			<v-subheader style="background-color:white"><h2 class="font-weight-light">{{getTitleScreen}}</h2></v-subheader>
			<v-divider></v-divider>
			<!-- Provides the application the proper gutter -->
			
			<router-view></router-view>
			
		</v-main>

		<!-- <v-footer app>
			<! -- -- >
		</v-footer> -->
	  </v-app>
</template>



<script>
	import {mapActions,mapGetters} from 'vuex';
	// import itemMenu from './components/base/itemMenu.vue';

    export default {
		data(){
			return {
				drawer:true,
				 admins: [
					['Management', 'mdi-account-multiple-outline'],
					['Settings', 'mdi-cog-outline'],
					]
			}
		},
    	// beforeCreate(){
	    //   	console.log('BEFORE CREATE');
	    //   	this.$store.dispatch('tryAutoLogin');
    	// }
    	computed:{
    		...mapGetters({
    			isAuth: 'app/isAuth',
    			getTitleScreen: 'app/getTitleScreen',
				getShowLoading:'app/getShowLoading',
				user:'app/user',
				menu: 'app/menu',
				nameApp: 'app/nameApp',
				tokenPainel:'app/tokenPainel',
			})
			// isAuth(){
			// 	return this.$store.getters.isAuth;
			// }
		},
		methods:{
			...mapActions({
				logout: 'app/logout'
			}),
			goto(link){
				this.$router.push({path: link}).catch(()=>{});
			}
			// logout(){
			// 	this.$store.dispatch('logout');
			// }
		},
		// components: { 
		// 	'item-menu': itemMenu, 
		// }
		created(){
			// console.log('AAA',this.$route.query)
			if(this.$route.query.tokenpainel && this.$route.query.tokenpainel!=''
				&& this.$route.params.id && this.$route.params.id !=''){
				
				this.$store.commit('app/tokenPainel',this.$route.query.tokenpainel);
			}
		}
    }
</script>


<style scoped>

 	div.popupBlock{
        width:100%;
        height:100%;
        top:0px;
        left:0px;
        z-index:100000;
        background-color:#000000;
        opacity: 0.5;
        filter: alpha(opacity = 50);
        position: fixed !important;  /* fixed faz a popup block acompanha o barra de rolagem */
    }


    div.load{

        top:50%;
        left:48%;
        height:100px;
        width:30px;
        z-index:30;
        position: fixed !important;
        margin:0 auto;
    }

</style>
